import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

// Components
import { Button, ExternalLinkButton, Modal, Text } from '../../..'

// Actions
import { answerYlopoOptIn, toggleYlopoOptInModal } from '../../../../actions/listings'

// Selectors
import { selectYlopoUrl } from '../../../../store/selectors/listings'

// Hooks
import { transformYlopoUrlForSizeHook } from '../../../../hooks/ylopo'

// Assets
import houseImg from './house.png'

// Styles
import styles from './YlopoOptInModal.module.scss'

const ModalTitle = () => (
  <>
    <img className={styles.image} src={houseImg} alt='house' />
    <Text
      variant='neutralCool'
      variantCount='900'
      element='div'
      size='l'
      weight='light'
    >
      <FormattedMessage
        id='YlopoOptInModal.title'
        defaultMessage='Our friend, Ylopo, provides home search'
      />
    </Text>
  </>
)

const YlopoOptInModal = () => {
  const dispatch = useDispatch()

  const ylopoBaseUrl = useSelector(selectYlopoUrl)
  const ylopoUrl = transformYlopoUrlForSizeHook(ylopoBaseUrl)

  return (
    <Modal
      className={styles.modal}
      data-qa='ylopoOptInModal'
      openKey='listings.showYlopoModal'
      title={<ModalTitle />}
      toggle={() => dispatch(toggleYlopoOptInModal())}
    >
      <Text variant='neutralCool' variantCount='700' element='div' size='m'>
        <FormattedMessage
          id='YlopoOptInModal.explanation'
          defaultMessage="We use a partner for home listings. By continuing, you'll go to their website. But it is easy to return to Homebot and we don't share any of your personal information!"
        />
      </Text>
      <Button.Group className={styles.buttonGroup}>
        <ExternalLinkButton
          className={styles.button}
          data-qa='ylopoOptInButton'
          onClick={() => {
            dispatch(answerYlopoOptIn())
            dispatch(toggleYlopoOptInModal())
          }}
          href={ylopoUrl}
          primary
        >
          <FormattedMessage
            id='YlopoOptInModal.optInButton'
            defaultMessage='Go to home listings'
          />
        </ExternalLinkButton>
        <Button
          className={styles.button}
          onClick={() => dispatch(toggleYlopoOptInModal())}
        >
          <FormattedMessage
            id='YlopoOptInModal.goBackButton'
            defaultMessage='Go back'
          />
        </Button>
      </Button.Group>
    </Modal>
  )
}

export default YlopoOptInModal
